<template>
  <site-banner pagina="blog" />

  <div id="post-lista" class="post-lista">
    <div v-if="!carregando" class="row">
      <div class="col-lg-8">
        <custom-lista
          v-if="!carregando"
          class="post-lista"
          :itens="itensRef"
          colunas="2"
        />
      </div>
      <div class="col-lg-4">
        <div class="row">
          <div class="col w-100">
            <site-post-sobre />
          </div>
        </div>
        <!-- <div class="row">
          <div class="col w-100">
            <div v-if="locale == 'pt'">
              <formulario-agenda-brasil />
            </div>
            <div v-if="locale == 'es'">
              <formulario-agenda-uruguai />
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script setup>
const { t, locale } = useI18n();
const carregando = ref(true);
const { data: noticias } = await useFetch("/api/site/posts", {
  headers: { "Content-Language": locale },
});
let itensRef = ref([]);

onMounted(() => {
  Object.values(noticias.value).forEach((item) => {
    itensRef.value.push({
      imagem: item.imagem_mobile,
      titulo: item.titulo,
      texto: item.descricao?.slice(0, 100) + "...",
      botao: { label: t("Ver mais"), url: `/blog/${item.slug}/` },
      class: "noticia-cartao",
    });
  });
  carregando.value = false;
});

useSeoMeta({
  title: `Blog - ${t("sorrifacil")}`,
  ogTitle: `Blog - ${t("sorrifacil")}`,
  description: `${t("O blog da")} ${t("sorrifacil")}`,
  ogDescription: `${t("O blog da")} ${t("sorrifacil")}`,
});
</script>

<script>
export default {
  name: "PostsPagina",
};
defineI18nRoute({
  paths: {
    pt: "/blog",
    es: "/blog",
  },
});
</script>
